export default {
  area: "河阳街道数智管理平台",
  objectName: "",
  //url
  // hostUrl: 'http://192.168.1.17:8087/',
  // apiHttpsUrl: 'http://192.168.1.17:8087/',
  // apiRequestUrl: 'http://192.168.1.17:8087',
  // apiUploadUrl: 'http://192.168.1.17:8087/common/OssUploadImg',
  // apiUploadFiles: 'http://192.168.1.17:8087/common/OssUploadImg',
  // apiUploadvideo: 'http://192.168.1.17:8087/UploadFile/UploadQiniuVideo',
  hostUrl: 'http://192.168.1.20:8087/',
  apiHttpsUrl: 'http://192.168.1.20:8087/',
  apiRequestUrl: 'http://192.168.1.20:8087',
  apiUploadUrl: 'http://192.168.1.20:8087/common/OssUploadImg',
  apiUploadFiles: 'http://192.168.1.20:8087/common/OssUploadImg',
  // apiUploadvideo: 'http://192.168.1.20:8087/UploadFile/UploadQiniuVideo',

  // hostUrl: "https://jlhyjd.anluoyun.cn/prod-api/",
  // apiHttpsUrl: "https://jlhyjd.anluoyun.cn/prod-api/",
  // apiRequestUrl: "https://jlhyjd.anluoyun.cn/prod-api",
  // apiUploadUrl: "https://jlhyjd.anluoyun.cn/prod-api/common/OssUploadImg",
  // apiUploadFiles: "https://jlhyjd.anluoyun.cn/prod-api/common/OssUploadImg",
  apiUploadvideo:
    "https://jlhyjd.anluoyun.cn/prod-api/UploadFile/UploadQiniuVideo",
  // 积分商城平台标识
  platformId: "hy_zhsq",
  // 审批平台标识
  platformId1: "shenpi",
};
